import {
  BD_GET_PACKINGSTANDARD_LISTING,
  BD_GET_PACKINGSTANDARD_LISTING_SUCCESS,
  BD_GET_PACKINGSTANDARD_LISTING_FAILED,
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    bdPackingStandard: null,
  }
  
  const bdPackingStandard = (state = initialState, action) => {
    switch (action.type) {
      case 
      BD_GET_PACKINGSTANDARD_LISTING:
        state = {
          ...state,
          loading: true,
          bdPackingStandard: action.payload,
        }
        break
      case BD_GET_PACKINGSTANDARD_LISTING_SUCCESS:
        state = { ...state, loading: false, bdPackingStandard: action.payload }
        break
      case BD_GET_PACKINGSTANDARD_LISTING_FAILED:
        state = { ...state, loading: false }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default bdPackingStandard
  